import './App.css'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import Home from './components/Home'
import Users from './components/Users'
import Project from './components/Project'
import Viewer from './components/Viewer'
import Command from './helpers/Command'
import { enableMapSet } from 'immer'

import { setupUserInputMessenger } from './helpers/user-input-messenger'
import { Login } from "./components/login/Login"
import { RepoLogin } from "./components/login/RepoLogin"
import { ProtectedRoute } from "./components/ProtectedRoute"
import { useEffect } from 'react'
import { useFeatureFlags } from './flags'
import { StandaloneSparqlPage, StandaloneToolPage } from './components/StandaloneToolPage'
import { V2Layout } from './v2/shared/v2-layout'
import { HomeV2 } from './v2/pages/home-v2'
import { UsersV2 } from './v2/pages/users-v2'
import { ProjectV2 } from './v2/pages/project-v2'

enableMapSet()
setupUserInputMessenger()

declare global {
  interface Window {
    CONNECTED_APPS_STATIC: any // lock&publish
  }
}

if (window.top) {
  (window.top as any).command = Command;
  //window.top.window.command=Command; /// handy for wistor apps running in a iframe
}

const wistorArt
  = " __      __.__          __                \r\n"
  + "/  \\    /  \\__| _______/  |_  ___________ \r\n"
  + "\\   \\/\\/   /  |/  ___/\\   __\\/  _ \\_  __ \\\r\n"
  + " \\        /|  |\\___ \\  |  | (  <_> )  | \\/\r\n"
  + "  \\__/\\  / |__/____  > |__|  \\____/|__|   \r\n"
  + "       \\/          \\/                     \r\n"

export function App() {
  if (window.CONNECTED_APPS_STATIC) {
    return <StaticApp />
  }

  return <PlatformApp />
}

function StaticApp() {
  return (
    <Router>
      <Switch>
          <Route path="/" exact component={Viewer} />
          <Route path="/loginbb" component={RepoLogin} />
          <Route path="*" component={Viewer} />
      </Switch>
    </Router>
  )
}

function PlatformApp() {
  const localModeIsActive = useFeatureFlags().localMode
  useEffect(() => { console.log(wistorArt) }, [])

  if (localModeIsActive) return (
    <Router>
      <Switch>
        <Route path="/:mode(edit|debug)?" component={Viewer} />
      </Switch>
    </Router>
  )

  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/loginbb" component={RepoLogin} />
          <Route path="/login" component={Login} />

          <ProtectedRoute exact path="/tools/sparql" component={StandaloneSparqlPage} />
          <ProtectedRoute exact path="/tools/:toolName" component={StandaloneToolPage} />

          {/* Wistor apps. Public-facing URLs — never move these. */}
          <ProtectedRoute
            protectIf={match => (match?.params as any)?.mode === "edit"}
            path="/projects/:projectPath/:viewerPath/:mode(edit|debug)?"
            component={Viewer}
          />

          {/* Previous platform GUI, kept reachable under /old */}
          <ProtectedRoute exact path="/old" component={Home} />
          <ProtectedRoute path="/old/users" component={Users} />
          <ProtectedRoute exact path="/old/projects/:projectPath" component={Project} />

          {/* Bookmarks from when the new GUI lived under /v2 */}
          <Redirect exact from="/v2/home" to="/" />
          <Redirect exact from="/v2/users" to="/users" />
          <Redirect exact from="/v2/projects/:projectPath" to="/projects/:projectPath" />

          {/* Platform GUI — the default */}
          <Route render={() => (
            <V2Layout>
              <Switch>
                <ProtectedRoute exact path="/" component={HomeV2} />
                <ProtectedRoute exact path="/users" component={UsersV2} />
                <ProtectedRoute exact path="/projects/:projectPath" component={ProjectV2} />
                <Redirect to="/" />
              </Switch>
            </V2Layout>
          )} />
        </Switch>
      </div>
    </Router>
  )
}
